import React, {useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import ExpandMore from "@mui/icons-material/ExpandMore";

import FeatureThumbnail from "../../visComponents/featureThumbnail";
import FeatureName from "../../visComponents/featureName";
import LookFeaturePrice from "../lookNavigation/lookMain/lookListFeature/lookFeaturePrice";
import LookListMainFeatureActions from "./listFeatureActions/lookListMainFeatureActions";
import LookFeatureQuantity from "./lookFeatureQuantity";
import {cartItemInterface} from "../../shoppingCart/cartItemInterface";
import LookListBundleFeatures from "./lookListBundleFeatures";
import {cartItemInStock, featureIsBundle, getBundledFeatures} from "../lookNavigation/lookFunctions2";
import {IS_LIXIL_SERVERS, IS_PRODUCT_JOURNEY} from "../../../config";
import GroheCartItemActions from "../grohe/groheCart/groheCartItemActions";
import LookListMainFeatureCheckbox from "./lookListMainFeatureCheckbox";
import LookListMainFeatureShipping from "./lookListMainFeatureShipping";
import {getFeatureGroupName, getFeatureIsLocked} from "../../../misc/helpers";
import LookFeatureSku from "../lookNavigation/lookMain/lookFeature/lookFeatureSku";

const LookListMainFeature = (props) => {

  const {intl, cartItem, quantity, cartItems, isBundleChild, showUnlockCalculations, showCartItems, cItemsAddedToParentCart,
    isMobile, withShipping, isPhoneNumberValidated, fabricatorData} = props;

  const fabricatorSettings = fabricatorData.settings;
  const {cartFeature} = cartItem;
  const [bundleExpanded, setBundleExpanded] = useState(true);

  const outOfStock = (
    <span className="lm-stock bold color-primary">
      <FormattedMessage id="look.feature.outOfStock"/>
    </span>
  );

  const expandBundleButton = (
    <IconButton aria-label={intl.formatMessage({id:"tooltip.editLook"})}
                className={"look-icon look-icon--small" + (bundleExpanded ? " look-icon--rotated" : "")}
                onClick={() => setBundleExpanded(!bundleExpanded)}>
      <ExpandMore/>
    </IconButton>
  );

  const relatedFeatures = getBundledFeatures(cartFeature);
  const isBundle = featureIsBundle(cartFeature, cartItems);
  const inStock = cartItemInStock(cartItem);
  const isBundleParent = isBundle && cartFeature.partId === "shower_fixture" && relatedFeatures.length > 1;

  const showPriceLocked = getFeatureIsLocked(cartFeature) || (fabricatorSettings.enableQuote && !isPhoneNumberValidated);

  return (
    <li className={"ll-feature"
      + (isBundle ? " ll-feature--bundled" : "")
      + (showPriceLocked ? " ll-feature--locked" : "")
      + (showUnlockCalculations ? " animated" : "")
      + (showUnlockCalculations ? showCartItems.includes(cartItem.id) ? " animate__fadeInRight" : " grohe-unc--hidden" : "")
      + (!IS_PRODUCT_JOURNEY && cItemsAddedToParentCart.includes(cartItem.id) ? " ll-feature--in-cart" : "")
      + (!inStock ? " ll-feature--no-stock" : "")
      + (cartItem.isRemoved ? " ll-feature--removed" : "")}>
      <div className="ll-feature__main">
        {withShipping ? null : <LookListMainFeatureCheckbox cartItem={cartItem}/>}
        <div className="lm-feature__thumbnail">
          <FeatureThumbnail feature={cartFeature}/>
        </div>
        <div className={"ll-feature__content" + (withShipping ? " ll-feature__content--shipping" : "")}>
          <span className="lm-feature__content-name">
            <FeatureName feature={cartFeature} useCollectionName={true}/> {isBundle
            ? <FormattedMessage id="look.list.bundle.items" values={{items: relatedFeatures.length}}/> : null}
          </span>
          <p className={"lm-feature__content-description lm-feature__content-description--max"
            + (withShipping ? " lm-feature__content-description--one-line" : "")}>
            {IS_LIXIL_SERVERS
              ? <FeatureName feature={cartFeature}/>
              : cartFeature.getParent ? getFeatureGroupName(cartFeature.getParent(), intl, fabricatorData) : null}
          </p>
          {!withShipping ? (
            <p className="lm-feature__content-model">
              <LookFeatureSku lookFeature={cartFeature} isList={true}/>
              {/*{isInStock(lookActiveFeature) ? null : (*/}
              {/*  <span className="lm-stock lm-stock--red">*/}
              {/*  <FormattedMessage id="look.feature.outOfStock"/>*/}
              {/*</span>*/}
              {/*)}*/}
            </p>
          ) : null}
          {withShipping ? <LookListMainFeatureShipping cartItem={cartItem}/> : null}
        </div>
        {(isMobile && withShipping) || !fabricatorSettings.showPricing ? null : (
          <div className="ll-feature__quantity">
            {isBundleParent ? null : (
              inStock ? <LookFeatureQuantity cartItem={cartItem} isBundle={isBundle}/> : outOfStock
            )}
          </div>
        )}
        {isBundle ? (
          <div className="ll-feature__expand">
            {expandBundleButton}
          </div>
        ) : null}
        {isBundleParent ? null : (
          <div className="ll-feature__price">
            <LookFeaturePrice lookFeature={cartFeature}
                              quantity={quantity}
                              listPage={true}
                              isBundleChild={isBundleChild}/>
          </div>
        )}
        {(isMobile && withShipping) || !fabricatorSettings.showPricing ? null
          : IS_PRODUCT_JOURNEY
            ? <GroheCartItemActions cartItem={cartItem} isRemoved={cartItem.isRemoved}/>
            : <LookListMainFeatureActions cartItem={cartItem}/>}
      </div>
      {isBundle && bundleExpanded ? <LookListBundleFeatures cartItem={cartItem}/> : null}
    </li>
  )
};

LookListMainFeature.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface).isRequired,
  withShipping: PropTypes.bool,
}

const mapStateToProps = (store, ownProps) => {
  const {lookExpanded, lookViewType} = store.lookState;
  const {cartItems, cItemsAddedToParentCart} = store.cartState;
  const {showUnlockCalculations, showCartItems} = store.unlockCalculationsState;
  const {isMobile} = store.serverState;
  const {isPhoneNumberValidated} = store.userState;
  const fabricatorData = store.fabricatorState;

  return {
    lookExpanded,
    lookViewType,
    quantity: ownProps.cartItem.quantity,
    cartItems,
    showUnlockCalculations,
    showCartItems,
    cItemsAddedToParentCart,
    isMobile,
    fabricatorData,
    isPhoneNumberValidated,
  };
};

const mapDispatchToProps = {

};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookListMainFeature)
)
